const isFrozenObject = (value) => {
    return Object.isFrozen(value);
}

export default isFrozenObject;